exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".word_style[data-v-6b4bbab2]{overflow:hidden;display:-webkit-box;-webkit-box-orient:vertical;text-overflow:ellipsis}.auto_list[data-v-6b4bbab2]::-webkit-scrollbar{width:1px!important;display:none!important}.clearfix[data-v-6b4bbab2]{*zoom:1}.clearfix[data-v-6b4bbab2]:after{content:\"\";display:block;height:0;clear:both;visibility:hidden}.simSun[data-v-6b4bbab2]{font-family:SimSun}", ""]);

// exports
